<template>
  <div>
    <span>{{ item.name + ", " + item.regionName }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
  }
}
</script>
